// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";

const systemListUrl = "api/custom/systemList/GetSystemListValues";

export interface GetSystemListValuesModel {
    systemListId: string;
    name: string;
    description: string;
    additionalInfo: string;
    isChecked: boolean;
    totalInvoicesAmount?: number;
}

export interface GetSystemListModel {
    result: GetSystemListValuesModel[];
}

export interface GetSystemListApiParameter extends ApiParameter {
    systemListName: string;
}

export async function getSystemList(parameter: GetSystemListApiParameter): Promise<ServiceResult<GetSystemListValuesModel[]>> {
    try {
        const getSystemListModel = await get<GetSystemListValuesModel[]>(`${systemListUrl}`, {
            systemListName: parameter.systemListName,
        } as GetSystemListApiParameter);
        return {
            result: getSystemListModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.message,
        };
    }
}
